import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import InvertColorsIcon from '@mui/icons-material/InvertColors';
import InvertColorsOffIcon from '@mui/icons-material/InvertColorsOff';
import { useDispatch, useSelector } from 'react-redux';
import { setInvertSideNavColors } from '@/features/userPrefs/userPrefsSlice';

export const InvertSideNavColorsButton = ({ color = 'whitesmoke' }) => {
	const dispatch = useDispatch();
	const inverted = useSelector((state) => state.userPrefs.invertSideNavColors);

	const handleToggle = () => dispatch(setInvertSideNavColors(!inverted));

	return (
		<Tooltip title={inverted ? 'Dark menu' : 'Light menu'} placement='right'>
			<IconButton size='small' onClick={handleToggle} sx={{ color }}>
				{inverted ? <InvertColorsOffIcon /> : <InvertColorsIcon />}
			</IconButton>
		</Tooltip>
	);
};
